(function () {
  'use strict';

  angular
    .module('crewSchedule')
    .controller('TrainingStagesCtrl', TrainingStagesCtrl);

  function TrainingStagesCtrl(modalParams,$uibModalInstance) {
    var vm = this;

    vm.model = {
      currentStage : modalParams.currentStage,
      crewTrainingStageDTOList : modalParams.crewTrainingStageDTOList,
      crewTrainingStageViolatedSectorList : modalParams.crewTrainingStageViolatedSectorList,
    };

    vm.onCloseClick = function () {
      $uibModalInstance.close(modalParams.close);
    }
  }
}());
